import LoginPage from '@/features/auth/routes/LoginPage'
import VendorRegisterPage from '@/features/vendors/routes/VendorRegisterPage'
import config, { APP_MODE } from '@/config'

const isProduction = config.mode == APP_MODE.PRODUCTION

const authRoutes = [
  {
    breadcrumb: 'Login',
    path: '',
    element: <LoginPage />,
  },
  {
    breadcrumb: 'Login',
    path: isProduction ? 'auth/login' : 'external/auth/login',
    element: <LoginPage />,
  },

  {
    breadcrumb: 'Register Vendor',
    path: isProduction ? 'register' : 'external/register',
    element: <VendorRegisterPage />,
  },
]

export default authRoutes
